import styled from 'styled-components'

export const Filters = styled.section`
  display: grid;
  gap: 18px;
  margin-bottom: 30px;
  padding: 18px 0 22px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`

export const FiltersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

export const FiltersTitle = styled.h2`
  margin: 0;
  color: ${p => p.theme.palette.colors.muted};
  font: 700 12px/1.4 Poppins, sans-serif;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`

export const ResetButton = styled.button`
  min-height: 36px;
  padding: 6px 10px;
  border: 0;
  background: transparent;
  color: ${p => p.theme.palette.blue.main};
  font: 700 12px/1 Poppins, sans-serif;
  cursor: pointer;

  &:hover { color: ${p => p.theme.palette.colors.text}; }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 2px; }
`

export const Periods = styled.div`
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 12px;
  background: ${p => p.theme.palette.colors.controlSurface};
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }

  @media (min-width: 760px) { width: fit-content; }
`

export const PeriodButton = styled.button`
  flex: 0 0 auto;
  min-height: 36px;
  padding: 7px 12px;
  border: 0;
  border-radius: 8px;
  background: ${p => p.active ? p.theme.palette.blue.main : 'transparent'};
  color: ${p => p.active ? p.theme.palette.blue.contrastText : p.theme.palette.colors.muted};
  font: 600 12px/1 Poppins, sans-serif;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;

  &:hover { color: ${p => p.active ? p.theme.palette.blue.contrastText : p.theme.palette.colors.text}; transform: translateY(-1px); }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`

export const CustomDates = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 190px));
  gap: 12px;

  @media (max-width: 480px) { grid-template-columns: 1fr; }
`

export const DateField = styled.label`
  display: grid;
  gap: 6px;
`

export const FilterLabel = styled.span`
  color: ${p => p.theme.palette.colors.muted};
  font: 600 11px/1.4 Poppins, sans-serif;
`

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 14px;
  padding-top: 6px;

  @media (max-width: 1240px) { grid-template-columns: repeat(3, minmax(150px, 1fr)); }
  @media (max-width: 700px) { grid-template-columns: repeat(2, minmax(130px, 1fr)); }
  @media (max-width: 430px) { grid-template-columns: 1fr; }
`

export const FilterControl = styled.div`min-width: 0;`

export const ActivityFilters = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 520px);
  gap: 12px;

  @media (max-width: 700px) { grid-template-columns: 1fr; }
`
